<template>
    <div style="min-height: 100vh;background: #F9F9FF;overflow-x: hidden;width: 100%">
        <CommonHeader/>
        <div class="head-bg">
            <img style="margin: 0 auto" src="../../img/bg2.png">
            <div>
            </div>
        </div>
        <div class="container" style="margin-top: -43px;min-height: calc(100vh - 56px - 193px + 32px - 77px);">
            <a-tabs v-model="activeKey" class="t1" type="card" @change='tabChange'>
                <a-tab-pane key="1" tab="项目信息">
                    <a-card>
                        <a-row>
                            <a-col :span="24">
                                <h1 class="text-center"> {{project.xmmc}}</h1>
                                <div class="d-flex justify-content-center border-bottom pb-5 mb-5">
                                    <div class="pl-5 pr-5 border-right">
                                        <span>项目编号：</span>
                                        <span class="color-black bold">  {{project.wbbh?project.wbbh:project.xmbh}}</span>
                                    </div>
                                    <div class="pl-5 pr-5">
                                        <span>调查方式：</span>
                                        <span class="color-black bold">
                                             {{project.extras.dcfsText}}
                                        </span>
                                    </div>
                                </div>
                                <table class="fx-form-view">
                                    <tr>
                                        <th>截止时间</th>
                                        <td colspan="3">
                                            {{project.dcjzsj|dayjs('YYYY/MM/DD HH:mm')}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>采购内容</th>
                                        <td colspan="3">
                                            {{project.cgnr}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>附件</th>
                                        <td colspan="3">
                                                <upload-selector :referId='project.xmid' readonly="readonly"
                                                                 configKey='tender_file'/>
                                        </td>
                                    </tr>
                                    <tr v-if=" announceList.length>0 && announceList[0].onlineSign === '1'">
                                        <th>公开下载的附件</th>
                                        <td colspan="3">
                                            <upload-selector :referId=' announceList[0].announceId' readonly="readonly"
                                                             configKey='common_tender_file'/>
                                        </td>
                                    </tr>
                                </table>
                                <a-col :span="24">
                                    <div class="d-division mt-5 mb-5"></div>
                                    <a-col :span="24">
                                        <a-divider class="color-orange mt-6" size="small" orientation="left">联系方式
                                        </a-divider>
                                    </a-col>
                                    <div class="contact">
                                        <div class="col">
                                            <div class="title">联系方式</div>
                                            <div class="info">
                                                <table class="table-a" style="margin-left:40%">
                                                    <th>委托人名称：</th>
                                                    <td class="color-black">{{project.wtrdwmc}}</td>
                                                    <tr>
                                                        <th>代理机构名称：</th>
                                                        <td class="color-black">{{project.dljgmc}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>地址：</th>
                                                        <td class="color-black">{{project.dljgdz}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>项目联系人：</th>
                                                        <td class="color-black">{{project.extras.nickName}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>联系电话：</th>
                                                        <td class="color-black">{{project.xmzbrdh}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </a-col>
                            </a-col>
                        </a-row>
                    </a-card>
                </a-tab-pane>
                <a-tab-pane key="2" tab="响应文件上传">
                    <demand-file :xmid="id"></demand-file>
                </a-tab-pane>
            </a-tabs>
        </div>
        <CommonFooter/>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'
    import UploadSelector from '@/components/selector/UploadSelector'
    import moment from 'moment'
    import DemandFile from "./DemandFile";


    export default {
        name: 'DemandList',
        components: {
            CommonHeader,
            CommonFooter,
            UploadSelector,
            moment,
            DemandFile
        },
        watch: {},
        created() {
            this.initRandom()
        },
        destroyed() {
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                project: {extras: {}},
                activeKey: "1",
                announceList: [],
            }
        },
        methods: {
            initRandom() {
                if (!sessionStorage.hasOwnProperty(this.id)) {
                    sessionStorage[this.id] = 1
                }
                this.initAnnounceList()
                this.initProjectInfo()
                this.activeKey = sessionStorage[this.id]
            },
            initProjectInfo() {
                let that = this
                this.$http.get("/api/1/demandSign/getDemandProjectDetails.json?projectId=" + this.id).then(function (res) {
                    that.project = res.project
                });
            },
            initAnnounceList() {
                let that = this
                this.$http.get('/api/v1/supplier/notice/getAnnounce/' + this.id).then(function (res) {
                    if (res.code === 200) {
                        that.announceList = res.result
                    }
                })
            },
            tabChange(activeKey) {
                switch (activeKey) {
                    case '1':
                        sessionStorage[this.id] = 1
                        break;
                    case '2':
                        sessionStorage[this.id] = 2
                        break;
                }
            },
        }
    };
</script>
<style lang="less" scoped>

    .head-bg {
        position: relative;
    }

    .head-bg div {
        position: absolute;
        top: 0;
        color: #fff;
        font-size: 36px;
        width: 100%;
        text-align: center;
        line-height: 60px;
        height: 60px;
        margin-top: 42px;
    }

    .head-bg div span {
        margin: 0 2px;
        display: inline-block;
        vertical-align: top;
    }

    .number {
        background: rgba(255, 22, 0, 0.35);
        font-size: 45px;
        padding: 0 12px;
    }

    .card-container /deep/ .ant-tabs-bar {
        margin: 0;
        border: none;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab {
        border: none;
        padding-bottom: 0;
        line-height: 44px;
        border-radius: 0;
        color: #fff;
        background: rgba(255, 255, 255, 0.4);
        font-size: 16px;
        flex: 1;
        text-align: center;
        height: 44px;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab:nth-last-child(1) {
        margin-right: 0;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab-active {
        color: #1890ff;
        background: #fff;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav-container {
        height: 44px;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card .ant-card-bordered {
        border: none;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav {
        display: block;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav > div {
        display: flex;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar {
        margin-bottom: 0;
        border-bottom: none;
    }

    .table-a {
        table-layout: fixed;
    }

    .table-a td {
        vertical-align: top;
        padding: 8px 0;
        font-size: 14px;
        font-weight: bold;
    }

    .table-a th {
        text-align: justify;
        text-align-last: justify;
        color: #8c8c8c;
        font-weight: 500;
        padding: 8px 0;
    }

    .contact {
        font-size: 0;
        margin: 0 -12px;
    }

    .contact .col {
        width: 100%;
        padding: 12px;
        box-sizing: border-box;
        font-size: 14px;
        display: inline-block;
    }
    .contact .col .title {
        background: #F3E4D8;
        padding: 12px;
    }

    .contact .col .info {
        border: 1px solid #e6e6e6;
        padding: 12px;
    }

    /deep/ .notice .p-0 .ant-card-body {
        padding: 0;
    }

    /deep/ .notice .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }

    /deep/ .notice .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }

    /deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td {
        background: #fff;
    }

    .fx-form-view th {
        border: 1px solid #e6e6e6;
        background-color: #f7f7f7;
    }

    .fx-form-view td {
        border: 1px solid #e6e6e6;
        width: 400px;
    }

    .fx-form-view {
        table-layout: auto;
    }
</style>
